var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_48236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 19.875C19.3956 19.875 20.375 18.8956 20.375 17.6875C20.375 16.4794 19.3956 15.5 18.1875 15.5C16.9794 15.5 16 16.4794 16 17.6875C16 18.8956 16.9794 19.875 18.1875 19.875Z",
    stroke: "#FF4C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 19.875C8.02062 19.875 9 18.8956 9 17.6875C9 16.4794 8.02062 15.5 6.8125 15.5C5.60438 15.5 4.625 16.4794 4.625 17.6875C4.625 18.8956 5.60438 19.875 6.8125 19.875Z",
    stroke: "#FF4C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5H19.5L22.125 11.125V15.5H16V8.5Z",
    stroke: "#FF4C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4.125H2.875V15.5H16V4.125Z",
    stroke: "#FF4C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_48236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiv);
export default __webpack_public_path__ + "static/media/liv.a9e63a317ca9fce71a24e943e55cbfba.svg";
export { ForwardRef as ReactComponent };